import Loadable from "react-loadable";

const LazyBesoinsCandidats = Loadable({
  loader: () => import(/* webpackChunkName: 'job-promise' */ "./index"),
  loading: () => 'loading...'
});

export default LazyBesoinsCandidats;
